



















































import { Component, Vue } from 'vue-property-decorator'
import { groupBy, Dictionary } from 'lodash'
import { ReferralNode } from '@/api/model/referral-node'
import { CompanyAPI } from '@/api/backend-client'
import ListReferralNodes from '@/views/Company/Settings/Sources/List/ListReferralNodes.vue'

@Component({
    components: {ListReferralNodes},
})
export default class CompanySettingsSourcesList extends Vue {
    incoming: ReferralNode[] = []
    outgoing: ReferralNode[] = []
    loadingIncoming: boolean = false
    loadingOutgoing: boolean = false

    async created(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loadingIncoming = true
        this.loadingOutgoing = true
        this.incoming = await CompanyAPI.getIncomingReferrals()
        this.loadingIncoming = false
        this.outgoing = await CompanyAPI.getOutgoingReferrals()
        this.loadingOutgoing = false
    }

    async navigateToCreate(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_sources_create',
        })
    }

    groupReferralNodes(value: ReferralNode[], key: string): Dictionary<ReferralNode[]> {
        const nodes = value.filter((node: ReferralNode) => {
            return node.source.id !== this.$currentCompany.id || node.target.id !== this.$currentCompany.id
        })

        return groupBy(nodes, key)
    }

    routeToEdit(referralNodeId: string) {
        return {
            name: `company_settings_sources_edit_outgoing`,
            params: {
                referralNodeId,
            },
        }
    }

    get internalReferralNodes() {
        return [...this.outgoing].filter((node: ReferralNode) => {
            return node.source.id === this.$currentCompany.id && node.target.id === this.$currentCompany.id
        })
    }

}
